<template>
    <div class="row full-screen">
        <SideBar/>
        <div class="col s12 m12 l10 right white">
          <h1>Mis Transacciones</h1> 
         
         <div class="row">
           <div class="input-field col s12 m4 l4">
              <input placeholder="digita la referencia o el booking" id="reference" type="text" class="validate"/>
              <label for="reference">Digite la referencia</label>
            </div>
            <a class="waves-effect waves-light btn indigo" v-on:click="findTransaction()">buscar<i class="material-icons left">search</i> </a>
          <!-- <a class="waves-effect waves-light btn indigo" v-on:click="testForReferer()">buscar<i class="material-icons left">search</i> </a>-->
         </div>
     
       <div class="divider"></div>
        <table class="centered">
        <thead>
          <tr>
              <th><i class="material-icons">date_range</i>Fecha</th>
              <th><i class="material-icons">flag</i>Referencia</th>
              <th><i class="material-icons">attach_money</i>valor Total</th>
              <th><i class="material-icons">border_color</i>booking</th>
              <th><i class="material-icons">announcement</i>estado</th>
              <th><i class="material-icons">subject</i>información</th>
          </tr>
        </thead>

        <tbody id="infoTransaction">
          <tr id="ddd"  v-bind:key="index" v-for="(info,index) in list">
            <td >{{info.creationdate.date}}</td>
            <td>{{info.ON}}-{{info.PN}}</td>
            <td>COP</td>
            <td>{{info.booking}}</td>
            <td>{{info.status}}</td>
            <td ><a class="waves-effect waves-light btn modal-trigger" v-on:click="moreInfoTran(index)" href="#infomodal" >Ver mas...</a></td>
          </tr>
        
        </tbody>
      </table>

      <!--modal info-->
    <div id="infomodal" class="modal modal-fixed-footer">
      <div class="modal-content" v-html="gio" style="text-align: center">
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat"><b>Cerrar</b></a>
      </div>
    </div>
  </div>
</div>
    
</template>
<script>
import M from 'materialize-css'
import SideBar from '../components/SideBar';
import axios from 'axios';
export default{
 data: () => { 
    return {
      list: [],
      elist:[],
      gio:""
      
    }
  },
  components:{
    SideBar
  },
  created: function () {
    this.$root.validateSesion()
    this.getInfoTransaction()
  },
   mounted:function() {
    M.Modal.init(document.querySelectorAll('.modal'))
    //this.getInfoTransaction()
   // M.Tooltip.init(document.querySelectorAll('.tooltipped'))
  },
  methods:{
    getInfoTransaction: function(){
    var data = JSON.stringify({
      "date": "2021-09-07 00:00:00",
      "limit": 10
    });
    var config = {
      method: 'post',
      url: 'https://cors-anywhere.herokuapp.com/http://qa.aviatur.com/restApp/general/getOrder',
      headers: { 
        'Accept': 'application/json', 
        'Content-Type': 'application/json', 
        'Authorization': 'Bearer M2ZiNDFhOTEwMDdmYzkzNjg1NzlkODNmOTdlNmUxNjE4ZTQyMDM4OGVmZmU2Yzc5OGM1YTg4Y2JhNmRjMGRiZQ'
      },
      data : data
    };
    axios(config)
    .then(response => { 
      let f = response.data.data
      console.log(f)
      //let v = JSON.parse(f.emissiondata)
      //let ss = v.OfficeID
      /*f.forEach(eee =>{
        console.log(eee.emissiondata)
        let r = JSON.parse(eee.emissiondata)
        if(r != null){
            if(r.OfficeID == "BOGB0910M3"){
               = eee
            }
            
        }
      })*/
      this.list = f
      /*let h = f.date
      console.log(h.slice(0,19))*/
    
    })
    .catch(error => {
      console.log(error);
    });
    },
    moreInfoTran: function(index){
      this.elist = this.list[index]
      let emission = this.elist.emissiondata
      emission = JSON.parse(emission)
      let rr = emission.OfficeID
      console.log(rr)
      let factData = emission.datos_facturacion
      factData = factData.replaceAll('/',' , ')
      let aditionalValue = emission.valores_adicionales
      aditionalValue = aditionalValue.replaceAll('/',' ')
      let k = ' <h4>Transaccion '+this.elist.ON+'-'+this.elist.PN+' </h4><table class="centered"><tbody Id="especificInfo" ><tr><td style="font-weight: 600">ID</td> <td>14785512536d5255a</td></tr>'+
        '<tr><td style="font-weight: 600">Fecha</td><td>'+this.elist.creationdate.date+'</td></tr>'+
        '<tr><td style="font-weight: 600">Descripcion</td><td>'+this.elist.description+'</td></tr>'+
        '<tr><td style="font-weight: 600">Booking</td><td>'+this.elist.booking+'</td></tr>'+
        '<tr><td style="font-weight: 600">Valor Total</td><td>78522</td></tr>'+
        '<tr><td style="font-weight: 600">Valores Adicionales</td><td>'+aditionalValue+'</td></tr>'+
        '<tr><td style="font-weight: 600">Datos Cliente</td><td>'+factData+'</td></tr>'+
        '<tr><td style="font-weight: 600">Estado</td><td>'+this.elist.status+'</td></tr></tbody></table>'
      this.gio = k
      
    },
    findTransaction: function(){
      let referen = document.getElementById("reference");
      let x = document.querySelectorAll("#ddd")
      let s = referen.value.trim()  
      let g = this.list
      console.log(g)
      //console.log(x.value)
      g.forEach((element,index) => {
        let ko = element.ON+'-'+element.PN
        if(element.booking==s || ko == s){        
           x[index].style.display = "table-row" 
        }else{
          x[index].style.display = "none"
        }
      });
      //console.log(referen.value)
    },
    /*testForReferer: function(){
      let referen = document.getElementById("reference");
      let rr = referen.value
      let ll = 0
      let rre = 0
      let reg = rr.split("")
      //if()
      reg.forEach((e,i) =>{
        if(ll < 2){
          if(e == " "){
            console.log(i)
            ll++
            rre = i
          }
        }
            
      })
      console.log(rre)
      console.log(reg.slice(0,rre).join(''))
      alert("referer is " + reg.slice(0,rre).join(''))
     
    }*/
  }
   
}
</script>
<style>

</style>